import { KlevuEvents, } from "../../events/index.js";
import { KlevuTypeOfRequest } from "../../models/KlevuTypeOfRequest.js";
const recommendationTypeOfRequests = [
    KlevuTypeOfRequest.AlsoBought,
    KlevuTypeOfRequest.AlsoViewed,
    KlevuTypeOfRequest.NewArrivals,
    KlevuTypeOfRequest.SimilarProducts,
    KlevuTypeOfRequest.Trending,
];
/**
 * This modifier should be used with all recommendation requests. It sends
 * correct event data to klevu backend on recommendation view
 *
 * @category Modifier
 * @returns
 */
export function sendRecommendationViewEvent(title, eventData, override) {
    return {
        klevuModifierId: "sendMerchandisingViewEvent",
        onResult: (res, f) => {
            var _a, _b, _c, _d, _e, _f;
            // is used with kmcRecommendation query
            if (f.klevuFunctionId === "kmcRecommendation") {
                const products = (_c = res.queriesById((_b = (_a = f.queries) === null || _a === void 0 ? void 0 : _a[0].id) !== null && _b !== void 0 ? _b : "")) === null || _c === void 0 ? void 0 : _c.records;
                if (!products) {
                    console.warn("No result in recommendations. Can't send recommendationViewEvent");
                    return res;
                }
                const kmcData = (_d = f.params) === null || _d === void 0 ? void 0 : _d.kmcConfig;
                if (!kmcData) {
                    console.warn("Problem with kmcData fetching. Can't send recommendationViewEvent");
                    return res;
                }
                if (products.length === 0) {
                    return res;
                }
                KlevuEvents.recommendationView({
                    recommendationMetadata: Object.assign(Object.assign({}, kmcData.metadata), { title }),
                    products,
                    override,
                });
                return res;
            }
            if (!eventData) {
                throw new Error("Need to provider eventData parameter for custom view events");
            }
            const queries = (_e = f.queries) === null || _e === void 0 ? void 0 : _e.filter((q) => recommendationTypeOfRequests.includes(q.typeOfRequest));
            if (!queries || (queries === null || queries === void 0 ? void 0 : queries.length) == 0) {
                return res;
            }
            const products = (_f = res.queriesById(queries[0].id)) === null || _f === void 0 ? void 0 : _f.records;
            if (!products) {
                console.warn("No products in result. Can't send recommendationViewEvent");
                return res;
            }
            KlevuEvents.recommendationView({
                recommendationMetadata: Object.assign(Object.assign({}, eventData), { title }),
                products,
            });
            return res;
        },
    };
}
